import { getFeature, isFeature } from 'Cloud/Application/FeaturesEs6';
import type { VoluntaryPromoConfig, VoluntaryPromoForceTrialConfig } from 'reactApp/ui/VoluntarilyBAZPromo/VoluntarilyBAZPromo.helpers';

/**
 * Включаем фичу так 3promo-enable-voluntarily-BAZ-promo
 */
export const VOLUNTARY_BAZ_PROMO_ID = 'voluntarily-BAZ-promo';

export const defaultVoluntaryBAZUpdateTariffs = {
    month: {
        64: 'W256GB_1m_landing_segmentation_discount',
        128: 'W256GB_1m_landing_segmentation_discount',
        256: 'W1TB_1m_landing_segmentation_discount',
        512: 'W1TB_1m_landing_segmentation_discount',
        1: 'W2TB_1m_landing_segmentation_discount',
        2: 'W2TB_1m_landing_segmentation_discount',
    },
    year: {
        64: 'W256GB_1y_landing_segmentation_discount',
        128: 'W256GB_1y_landing_segmentation_discount',
        256: 'W1TB_1y_landing_segmentation_discount',
        512: 'W1TB_1y_landing_segmentation_discount',
        1: 'W2TB_1y_landing_segmentation_discount',
        2: 'W2TB_1y_landing_segmentation_discount',
    },
};
export const defaultVoluntaryBAZForceTrialTariffs = {
    month: 'W256G1m_trial_2023_single_quota_cloud',
    year: 'W256G1y_trial_2023_single_quota_cloud',
};

export const voluntarilyBAZPromoEnabled: boolean = isFeature('voluntarily-BAZ-promo-enabled') || false;
export const voluntarilyBAZPromoTariff: VoluntaryPromoConfig =
    getFeature('voluntarily-BAZ-promo-tariff') || defaultVoluntaryBAZUpdateTariffs;

export const voluntarilyBAZPromoForceTrial = isFeature('voluntarily-BAZ-promo-force-trial');
export const voluntarilyBAZPromoForceTrialTariffs: VoluntaryPromoForceTrialConfig =
    getFeature('voluntarily-BAZ-promo-force-trial-tariffs') || defaultVoluntaryBAZForceTrialTariffs;

export const voluntarilyBAZPromoConfig = getFeature(`${VOLUNTARY_BAZ_PROMO_ID}-config`) || {
    showLimit: 3,
    closeLimit: 3,
    showInterval: 60 * 60 * 24 * 3,
};
